$(document).ready(function() {
    // Load saved pincode
    var Existing_pin = localStorage.getItem('ExistPincode');
    if (Existing_pin) {
        $('#pincode_1').val(Existing_pin);
        if (Existing_pin.length === 6 && !isNaN(Existing_pin)) {
            // WFW DELIVERY SLA START — /status handled in delivery-sla.js
            document.dispatchEvent(new CustomEvent('wfw:pincode-updated', { detail: { pincode: Existing_pin } }));
            // WFW DELIVERY SLA END
        }
    }

    function isSixDigitPin(pin) {
        return /^\d{6}$/.test(String(pin || '').trim());
    }

    function clearFakeInvalidPinError() {
        var msg = $('#responsemessage');
        if (msg.hasClass('error') && /valid 6 digit/i.test(msg.text() || '')) {
            msg.text('').removeClass('error');
        }
    }

    function onPincodeFieldChange() {
        var input = $('#pincode_1');
        if (!input.length) return;

        var pincode = String(input.val() || '').replace(/\D/g, '').slice(0, 6);
        if (input.val() !== pincode) {
            input.val(pincode);
        }

        if (!isSixDigitPin(pincode)) {
            clearFakeInvalidPinError();
            return;
        }

        localStorage.setItem('ExistPincode', pincode);
        // WFW DELIVERY SLA START — serviceability + Free Delivery via /api/delivery/status in delivery-sla.js
        document.dispatchEvent(new CustomEvent('wfw:pincode-updated', { detail: { pincode: pincode } }));
        // WFW DELIVERY SLA END
    }

    // input/change/paste: mobile number pads often skip keyup.
    $('#pincode_1').on('keyup input change paste', onPincodeFieldChange);
    $('#pincode_1').on('blur', function () {
        var pincode = String($(this).val() || '').trim();
        if (pincode.length && !isSixDigitPin(pincode)) {
            $('#responsemessage')
                .text('Please enter a valid 6 digit pincode')
                .removeClass('success')
                .addClass('error');
        }
    });

    // WFW DELIVERY SLA START — old Shiprocket serviceability (replaced by /api/delivery/status in delivery-sla.js)
    // function checkPincode(pincode) {
    //     const apiUrl = `https://shopify.wforwoman.com/pincodes/shiprocket/service/${pincode}`;
    //
    //     $.ajax({
    //         url: apiUrl,
    //         method: 'GET',
    //         dataType: 'json',
    //         success: function(response) {
    //             if (response.success &&
    //                 response.data &&
    //                 response.data.data &&
    //                 Array.isArray(response.data.data.available_courier_companies) &&
    //                 response.data.data.available_courier_companies.length > 0) {
    //
    //                 const firstCourier = response.data.data.available_courier_companies[0];
    //                 const estDays = parseInt(firstCourier.estimated_delivery_days || 1, 10);
    //                 localStorage.setItem('ExistPincode', pincode);
    //                 localStorage.setItem('TAT', estDays);
    //                 getDeliveryData(estDays);
    //
    //             } else {
    //                 $('#responsemessage').html('Pincode Not Servicable').removeClass('success').addClass('error');
    //             }
    //         },
    //         error: function() {
    //             $('#responsemessage').html('Error fetching delivery info. Please try again.').removeClass('success').addClass('error');
    //         }
    //     });
    // }
    //
    // function getDeliveryData(days) {
    //     const next_dt = new Date();
    //     next_dt.setDate(next_dt.getDate() + days);
    //
    //     const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    //     const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    //
    //     const monthName = monthNames[next_dt.getMonth()];
    //     const dayName = dayNames[next_dt.getDay()];
    //     const date = next_dt.getDate();
    //
    //     $('#responsemessage').html(
    //         `<span class="span2"><u>Free Delivery:</u> <b>${dayName}, ${monthName} ${date}</b></span>`
    //     ).removeClass('error').addClass('success');
    // }
    // WFW DELIVERY SLA END
});


// { OLD - Code }

// $(document).ready(function() {
//     // Load saved pincode
//     var Existing_pin = localStorage.getItem('ExistPincode');
//     if (Existing_pin) {
//         $('#pincode_1').val(Existing_pin);
//         // Auto check if already saved
//         checkPincode(Existing_pin);
//     }

//     // On keyup (real-time check)
//     $('#pincode_1').keyup(function() {
//         const pincode = $(this).val().trim();

//         if (pincode.length !== 6 || isNaN(pincode)) {
//             $('#responsemessage').text('Please enter valid 6 digit Pincode').removeClass('success').addClass('error');
//             return;
//         }

//         checkPincode(pincode);
//     });

//     // Main function
//     function checkPincode(pincode) {
//         const apiUrl = `https://shopify.wforwoman.com/pincodes/shiprocket/service/${pincode}`;

//         $.ajax({
//             url: apiUrl,
//             method: 'GET',
//             dataType: 'json',
//             success: function(response) {
//                 if (response.success && 
//                     response.data && 
//                     response.data.data && 
//                     Array.isArray(response.data.data.available_courier_companies) && 
//                     response.data.data.available_courier_companies.length > 0) {

//                     // Servicable hai
//                     const firstCourier = response.data.data.available_courier_companies[0];
//                     const estDays = parseInt(firstCourier.estimated_delivery_days || 1, 10);

//                     localStorage.setItem('ExistPincode', pincode);
//                     localStorage.setItem('TAT', estDays);

//                     getDeliveryData(estDays);

//                 } else {
//                     // Not servicable
//                     $('#responsemessage').html('Pincode Not Servicable').removeClass('success').addClass('error');
//                 }
//             },
//             error: function() {
//                 $('#responsemessage').html('Error fetching delivery info. Please try again.').removeClass('success').addClass('error');
//             }
//         });
//     }

//     // Date calculation function
//     function getDeliveryData(days) {
//         const next_dt = new Date();
//         next_dt.setDate(next_dt.getDate() + days);

//         const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
//         const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

//         const monthName = monthNames[next_dt.getMonth()];
//         const dayName = dayNames[next_dt.getDay()];
//         const date = next_dt.getDate();

//         $('#responsemessage').html(
//             `<span class="span2"><u>Free Delivery:</u> <b>${dayName}, ${monthName} ${date}</b></span>`
//         ).removeClass('error').addClass('success');
//     }
// });